import { type Context, useContext } from 'react'

import { throwNull } from '../utils/typecheck'

export function useContextSafely<T>(context: Context<T | null>, hookName: string): T {
    return throwNull(useContext(context), `use${hookName} must be used inside ${hookName}Provider!`)
}
